import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/pingce', label: '平台评测' },
  { to: '/category/youhui', label: '优惠活动' },
  { to: '/category/peilv', label: '赔率分析' },
  { to: '/category/anquan', label: '安全指南' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" onClick={handleLinkClick}>
            <span className="text-2xl font-bold font-heading text-foreground-900">
              博彩<span className="text-accent-500">网</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to));
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? 'bg-accent-100 text-accent-700'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className="hidden md:inline-flex items-center px-5 py-2 bg-accent-500 text-background-50 rounded-md text-sm font-medium hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap"
            >
              联系我们
            </Link>
            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
              aria-label={menuOpen ? '关闭菜单' : '菜单'}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            menuOpen ? 'max-h-96 pb-4' : 'max-h-0'
          }`}
        >
          <div className="flex flex-col gap-1 pt-2 border-t border-background-200/70">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to));
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={handleLinkClick}
                  className={`px-4 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? 'bg-accent-100 text-accent-700'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/about"
              onClick={handleLinkClick}
              className="mt-2 px-4 py-2.5 bg-accent-500 text-background-50 rounded-md text-sm font-medium text-center hover:bg-accent-600 transition-colors duration-200"
            >
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}